/**
 * OIDC Helper Functions
 *
 * Shared logic for determining OIDC eligibility across client and server.
 *//**
 * Check if a hostname is the vibes.ai domain (production NUX experience).
 * This controls whether users see the NUX landing page vs legacy login.
 *
 * @param host - The hostname (e.g., 'vibes.ai', 'www.vibes.ai')
 * @returns true if this is a vibes.ai domain
 */export function isVibesAiDomain(host:string):boolean{// Strip port if present
const hostname=host.split(':')[0];return hostname==='localhost'||hostname==='vibes.ai'||hostname==='www.vibes.ai';}/**
 * Check if the user just returned from Meta OIDC authentication.
 * Uses document.referrer to detect if we came from auth.meta.ai or related domains.
 *
 * This replaces sessionStorage-based tracking and naturally handles the
 * "returning from OIDC" case without needing to set/clear flags.
 *
 * @returns true if referrer indicates we came from Meta OIDC flow
 */export function isReturningFromOidc():boolean{if(typeof document==='undefined')return false;const referrer=document.referrer;if(!referrer)return false;try{const url=new URL(referrer);const{hostname}=url;const isFromDomain=(domain:string)=>hostname===domain||hostname.endsWith('.'+domain);// Check for Meta auth domains (auth.meta.ai, meta.ai, facebook.com)
return isFromDomain('meta.ai')||isFromDomain('facebook.com')||isFromDomain('meta.com');}catch{return false;}}/**
 * Check if a hostname is allowed to use OIDC authentication.
 * Works on both client and server.
 *
 * As of Jan 2026, OIDC is enabled for all domains.
 *
 * @param host - The hostname (e.g., 'localhost:3000', 'preview.par-msl.dev')
 * @returns true (OIDC is always allowed)
 */export function isOidcAllowedDomain(_host:string):boolean{return true;}